import Vue from 'vue';

// vue-meta
import VueMeta from 'vue-meta';

// hooper
import 'hooper/dist/hooper.css';

// animate of scroll
import AOS from 'aos';
import 'aos/dist/aos.css';

import BootstrapVue from 'bootstrap-vue';
// vue-lazyload
import VueSimpleAlert from 'vue-simple-alert';
// masonry
import { VueMasonryPlugin } from 'vue-masonry';
// vue-infinite-scroll
import infiniteScroll from 'vue-infinite-scroll';
import VueLazyload from '@/plugins/vue-lazyload';
// loading
import Loading from '@/plugins/vue-loading-overlay';

// Bootstrap
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

// filter
import dateFilter from '@/filters/date';

// toasted
import Toasted from '@/plugins/toasted';

// axios
import axios from '@/axios/index';

// router
import router from './router';
// Vuex
import store from './store';
// pages
import App from './App.vue';

// global scss
import '@/assets/scss/all.scss';

Vue.use(VueMeta);
Vue.use(BootstrapVue);
Vue.use(Loading);
Vue.use(VueSimpleAlert);
Vue.use(VueMasonryPlugin);
Vue.use(infiniteScroll);

Vue.filter('date', dateFilter);

new Vue({
  created() {
    AOS.init();
  },
  router,
  store,
  axios,
  Toasted,
  VueLazyload,
  render: h => h(App),
}).$mount('#app');

Vue.config.productionTip = false;
